import React, { useState, Alert} from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/Login.css';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: '',
    role: 'admin' ,
  });

  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post('/api/register', formData);
      setMessage(res.data.message);
      if (res.status === 200 || res.status === 201) {
        console.log("Login success, navigating to dashboard");
        // Redirect to dashboard
        //navigate('/dashboard');
          const user = res.newUser; // 👈 This is where user.email comes from
       console.log('user', user);
       setFormData({
          name: '',
          email: '',
          password: '',
          phone: '',
          role: 'admin'
        });
        
        setMessage(`${formData.role.toUpperCase()} account created successfully!`);
        alert("Member created successfully");
      // ✅ Store email in session storage
      //sessionStorage.setItem('userEmail', user.email);
      //sessionStorage.setItem('userName', user.name); // Optional
        //navigate('/dashboard');
      }
    } catch (error) {
      console.log(error);
      if (error.res?.data?.error) {
        setMessage(error.res.data.error);
      } else {
        setMessage("Something went wrong");
      }
    }
  };

  return (
  <div className="login-container">
     
        

        <form className="login-form" onSubmit={handleSubmit}>
            <h2>Create Account</h2>
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            onChange={handleChange}
            required
            //className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            onChange={handleChange}
            required
            //className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            onChange={handleChange}
            required
            //className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          />
          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            onChange={handleChange}
            required
            //className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          />
          <div style={{ marginBottom: '20px' }}>
          <label style={{ 
            display: 'block', 
            marginBottom: '8px', 
            fontWeight: 'bold',
            color: '#333'
          }}>
            Select Role:
          </label>
          <div style={{ display: 'flex', gap: '20px' }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="radio"
                name="role"
                value="admin"
                checked={formData.role === 'admin'}
                onChange={handleChange}
                style={{ marginRight: '8px' }}
              />
              Admin
            </label>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="radio"
                name="role"
                value="hr"
                checked={formData.role === 'hr'}
                onChange={handleChange}
                style={{ marginRight: '8px' }}
              />
              HR
            </label>
          </div>
        </div>
          <button
            type="submit"
            //className="w-full bg-purple-600 text-white py-2 rounded-xl hover:bg-purple-700 transition"
          >
            Register
          </button>
          {/* <p >
          Already have an account?{" "}
          <span
            onClick={() => navigate("/login")}
            //className="text-blue-600 font-medium cursor-pointer hover:underline"
          >
            Login here
          </span>
        </p> */}
        </form>

        
      </div>
   
  );
};

export default Register;
